//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RepairBox',
  data: function data() {
    return {
      dialogVisible: false,
      instru: {}
    };
  },
  methods: {
    // 显示弹窗
    handleShow: function handleShow(data) {
      this.dialogVisible = true;
      this.instru = data;
    },
    // 去填写维修信息
    handleDealWith: function handleDealWith() {
      var query = "?repairId=".concat(this.instru.repairId);
      this.$router.push("/workbench/releaseRepair".concat(query));
      this.handleClose();
      console.log(this.$route.path);
      // 当前页面就是报修页面，需要强制刷新页面，更新填写信息
      if (this.$route.path === '/workbench/releaseRepair') {
        this.$router.go(0);
      }
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.instru = {};
    }
  }
};